import t from './actionTypes'

export const loadNotes = (notes) => ({
  type: t.LOAD_NOTE_LIST,
  payload: notes,
})

export const setExpandNote = (id, bool) => ({
  type: t.EXPAND_NOTE,
  payload: { id, bool },
})

export const setExpandAll = (bool) => ({
  type: t.EXPAND_ALL,
  payload: bool,
})

export const loadNote = (note, id) => ({
  type: t.LOAD_NOTE,
  payload: { note, id },
})

export const loadingNote = (id) => ({
  type: t.LOADING_NOTE,
  payload: id,
})

export const setNoteMax = (max) => ({
  type: t.SET_NOTE_MAX,
  payload: max,
})

export const setDate = (datename, date) => ({
  type: t.SET_DATE,
  payload: { datename, date },
})

export const loadPostNote = (note) => ({
  type: t.LOAD_POST_NOTE,
  payload: note,
})

export const validatePostNote = (bool) => ({
  type: t.VALIDATE_POST_NOTE,
  payload: bool,
})

export const toggleCanPostNote = (bool) => ({
  type: t.CAN_POST_NOTE,
  payload: bool,
})

export const postingNote = (bool) => ({
  type: t.POSTING_NOTE,
  payload: bool,
})

export const clearPostNote = (state) => ({
  type: t.CLEAR_POST_NOTE,
  payload: state,
})

export const setFilterStr = (func) => ({
  type: t.SET_FILTER_STR,
  payload: func,
})
